<template>
  <base-container :isLoading="loading" style="height: 100%">
    <ArtisanGrid
      ref="project"
      metaKey="JcProjectInfo"
      :confirmAfter="loadTreeData"
      :delRowAfter="loadTreeData"
      :leftOption="{ width: '20%' }"
      :showDialogBefore="showDialogBefore"
      @setProjectTag="setProjectTag"
    >
      <template #isLimosis="{ row }">
        <el-switch
          v-model="row.isLimosis"
          active-color="#13ce66"
          @change="change(row)"
        ></el-switch>
      </template>
      <template #projectTags="{ row }">
        <span>{{ getTagNames(row.projectTags) }}</span>
      </template>
      <template #leftAside>
        <artisan-group style="height: 100%; border: none; overflow-y: auto">
          <div slot="header">
            <span>院区科室</span>
          </div>
          <el-tree
            :data="treeData"
            node-key="id"
            ref="tree"
            :default-expanded-keys="expandedKeys"
            highlight-current
            :props="defaultProps"
            :expand-on-click-node="false"
            @current-change="treeChange"
          >
          </el-tree>
        </artisan-group>
      </template>
    </ArtisanGrid>
    <artisan-dialog
      ref="dialog"
      :title="dialog.title"
      :visible.sync="dialog.isShow"
      height="75%"
      width="50%"
    >
      <artisan-group title="选中的项目" style="height: 40%">
        <el-tag
          style="margin: 5px"
          v-for="name in dialog.projectNames"
          :key="name"
          >{{ name }}</el-tag
        >
      </artisan-group>
      <artisan-group title="设置的标签" style="height: 60%">
        <el-tag
          type="danger"
          class="clickable"
          style="margin: 5px"
          v-for="tag in tags"
          :key="tag.tagCode"
          :effect="dialog.tagCodes.indexOf(tag.tagCode) >= 0 ? 'dark' : 'light'"
          @click="checkProjectTag(tag.tagCode)"
          >{{ tag.tagName }}</el-tag
        >
      </artisan-group>
      <template #footer>
        <el-button
          size="mini"
          type="danger"
          icon="el-icon-delete"
          @click="dialog.isShow = false"
        >
          取消
        </el-button>
        <el-button
          size="mini"
          type="success"
          icon="el-icon-check"
          @click="toSaveProjectTags"
        >
          确认
        </el-button>
      </template>
    </artisan-dialog>
  </base-container>
</template>

<script>
import { getHosDepts } from "@/api/jc/dept";
import { buildTree } from "@/util/util";
import { editProject, saveProjectTag } from "@/api/jc/project";
import { listByType } from "@/api/basis/tag";
export default {
  data() {
    return {
      loading: false,
      treeData: [],
      tags: [],
      parts: [],
      expandedKeys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      dialog: {
        title: "标签设置",
        isShow: false,
        projectNames: [],
        tagCodes: [],
      },
    };
  },
  computed: {
    tagMap() {
      return new Map(
        this.tags.map(({ tagCode, tagName }) => [tagCode, tagName])
      );
    },
  },
  created() {
    listByType("project").then((res) => {
      this.tags = res.data.data;
    });
    getHosDepts().then((res) => {
      let data = res.data.data;
      let root = {
        id: "",
        name: "所有",
        children: [],
      };
      data.forEach((item) => {
        const deptTree = buildTree(item.depts);
        this.expandedKeys.push("hos" + item.id);
        root.children.push({
          id: "hos" + item.id,
          name: item.name,
          hosId: item.id,
          isHos: true,
          children: deptTree,
        });
      });
      this.treeData.push(root);
    });
  },
  methods: {
    getTagNames(tagCodes) {
      if (tagCodes) {
        let codeArr = tagCodes.split(",");
        return codeArr.map((c) => this.tagMap.get(c)).join(",");
      }
      return "";
    },
    change(row) {
      editProject(row).then((res) => {});
    },
    loadTreeData() {
      this.$refs.project.reloadDicByCol("parentId");
    },
    treeChange(data) {
      if (data.id) {
        if (data.isHos) {
          this.$refs.project.reload({
            hosId: data.hosId,
            deptId: "",
          });
        } else {
          this.$refs.project.reload({
            hosId: data.hosId,
            deptId: data.id,
          });
        }
      } else {
        this.$refs.project.reload({ hosId: "", deptId: "" });
      }
    },
    showDialogBefore(dialog) {
      let col = this.$refs.project.getColumn("projectTags");
      if (!col.dicData.length) {
        col.dicData = this.tags.map((c) => {
          return {
            value: c.tagCode,
            label: c.tagName,
          };
        });
      }
      dialog.isShow = true;
    },
    setProjectTag() {
      let rows = this.$refs.project.tableSelectRows;
      if (rows.length) {
        this.dialog.projectNames = rows.map((c) => c.name);
        this.dialog.tagCodes = [];
        this.dialog.isShow = true;
      } else {
        this.$message({
          type: "warning",
          message: "请选择要设置标签的检查项目！",
        });
      }
    },
    checkProjectTag(tagCode) {
      let index = this.dialog.tagCodes.indexOf(tagCode);
      if (index >= 0) {
        this.dialog.tagCodes.splice(index, 1);
      } else {
        this.dialog.tagCodes.push(tagCode);
      }
    },
    toSaveProjectTags() {
      this.$refs.dialog
        .confirm({ msg: "确认保存项目标签设置？" })
        .then(() => {
          let rows = this.$refs.project.tableSelectRows;
          let ids = rows.map((c) => c.id).join(",");
          this.loading = true;
          return saveProjectTag(ids, this.dialog.tagCodes.join(","));
        })
        .then(() => {
          this.loading = false;
          this.$refs.project.reload();
          this.dialog.isShow = false;
          this.$message({
            type: "success",
            message: "保存成功！",
          });
        });
    },
  },
};
</script>

<style></style>
